module.exports = __webpack_public_path__ + "static/media/JPEG.1.bae3b25d.png";